import { addSpecificFields, addGenericFields } from './definitions'

const createFields = (fieldType, initialValues, intl, options) => [
  ...addGenericFields(fieldType, initialValues, intl, options),
  ...addSpecificFields(fieldType, initialValues, intl, options),
]

export default createFields
